var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgActiveIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 21,
  height: 20,
  viewBox: "0 0 21 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.600098 0H13.6001L20.6001 4V20H7.6001L0.600098 16V0Z",
  fill: "#A3E0B4"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.8287 7.65535L9.57869 12.9053C9.38343 13.1006 9.06684 13.1006 8.87158 12.9053L6.37158 10.4053L7.07869 9.69824L9.22514 11.8447L14.1216 6.94824L14.8287 7.65535Z",
  fill: "#138634"
})));
export { SvgActiveIcon as ReactComponent };
export default __webpack_public_path__ + "assets/ded2830f.svg";